<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/zhaoshang/customer' }">客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>新增客户</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">新增客户</span>
      </div>

      <el-form :model="form" ref="formRef" :rules="formRules" label-width="120px" :inline="false" size="normal" style="max-width:600px">
        <!-- 客户标题 -->
        <el-form-item label="客户名称：" prop="title">
          <el-input v-model="form.title" placeholder="地区+客户称呼，如北京张总" maxlength="50"></el-input>
        </el-form-item>

        <!-- 联系人姓名 -->
        <el-form-item label="联系人姓名：" prop="name">
          <el-input v-model="form.name" placeholder="请输入联系人姓名，2-15个字符" maxlength="15"></el-input>
        </el-form-item>

        <!-- 手机号 -->
        <el-form-item label="手机号：" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入11位有效手机号" maxlength="11"></el-input>
        </el-form-item>

        <!-- 身份证号 -->
        <el-form-item label="身份证号：" prop="idCard">
          <el-input v-model="form.idCard" :placeholder="idCardRequired ? '请输入18位身份证号' : '请输入18位身份证号（选填）'" maxlength="18"></el-input>
        </el-form-item>

        <!-- 客户来源 -->
        <el-form-item label="客户来源：" prop="from">
          <el-select v-model="form.from" placeholder="请选择客户来源" style="width: 100%">
            <el-option v-for="item in fromList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <!-- 创建人（归属人） -->
        <el-form-item label="创建人：" prop="creatorId">
          <el-select v-model="form.creatorId" placeholder="请选择创建人（员工）" filterable style="width: 100%" @change="onCreatorChange" :disabled="!isCreatorEditable">
            <el-option v-for="item in employeeList" :key="item._id" :label="item.name" :value="item._id"></el-option>
          </el-select>
        </el-form-item>

        <!-- 创建人堆雪球账号 -->
        <el-form-item label="归属人微信：" prop="creatorDxqId">
          <el-select v-model="form.creatorDxqId" placeholder="请选择创建人堆雪球账号（选填）" filterable style="width: 100%" @change="onCreatorDxqChange" :disabled="!isCreatorDxqEditable">
            <el-option label="不选择" value=""></el-option>
            <el-option v-for="item in dxqAccountList" :key="item.id" :label="item.nickname" :value="item.id">
              <div style="display: flex; align-items: center;">
                <img :src="item.avatar" alt="头像" style="width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
                <span>{{ item.nickname }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 客户堆雪球账号/微信好友 -->
        <el-form-item label="客户微信：" prop="customerDxqId">
          <el-select v-model="form.customerDxqId" placeholder="请选择客户的微信好友（选填）" style="width: 100%" :disabled="!form.creatorDxqId" filterable remote :remote-method="searchWechatFriends" :loading="loadingWechatFriends">
            <el-option label="不选择" value=""></el-option>
            <el-option v-for="item in wechatFriendList" :key="item.id" :label="item.nickname" :value="item.id">
              <div style="display: flex; align-items: center;">
                <img :src="item.avatar" alt="头像" style="width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
                <span>{{ item.nickname }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 备注 -->
        <el-form-item label="备注：" prop="remark">
          <el-input v-model="form.remark" type="textarea" placeholder="请输入备注信息（最多500字符）" maxlength="500" rows="4"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submitting" @click="okClickHandler">添加客户</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>

    </el-card>

  </div>
</template>

<script>
import { fromList } from '@/utility/staticData'
export default {
  data () {
    // 手机号验证
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的11位手机号'))
      } else {
        callback()
      }
    }

    // 身份证号验证
    const validateIdCard = (rule, value, callback) => {
      if (value && !/^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/.test(value)) {
        callback(new Error('请输入正确的18位身份证号'))
      } else {
        callback()
      }
    }

    // 2026-09-09（北京时间）起成交客户必须填写身份证号，历史数据不强制
    const idCardRequired = Date.now() >= new Date('2026-09-09T00:00:00+08:00').getTime()

    return {
      // 当前账号的信息
      accountInfo: {},

      // 表单数据
      form: {
        title: '', // 客户标题
        name: '', // 联系人姓名
        mobile: '', // 手机号
        idCard: '', // 身份证号
        from: '', // 客户来源
        creatorId: '', // 创建人ID
        creatorName: '', // 创建人姓名
        creatorDxqId: '', // 创建人堆雪球ID
        customerDxqId: '', // 客户堆雪球ID
        remark: '' // 备注
      },
      // 员工列表
      employeeList: [],
      // 客户来源列表
      fromList: fromList, // 客户来源列表
      // 堆雪球账号列表
      dxqAccountList: [],
      // 微信好友列表
      wechatFriendList: [],
      // 是否加载中
      loadingWechatFriends: false,
      // 字段是否可编辑
      isCreatorEditable: true,
      isCreatorDxqEditable: true,
      // 提交中标志位（防重复点击）
      submitting: false,
      // 身份证号是否必填（2026-09-09起）
      idCardRequired,

      // 表单验证规则
      formRules: {
        title: [
          { type: 'string', required: true, message: '请输入客户标题', trigger: 'blur' },
          { type: 'string', min: 2, max: 50, message: '客户标题必须为2-50个字符', trigger: 'blur' }
        ],
        name: [
          { type: 'string', required: true, message: '请输入联系人姓名', trigger: 'blur' },
          { type: 'string', min: 2, max: 15, message: '联系人姓名必须为2-15个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, validator: validateMobile, trigger: 'blur' }
        ],
        idCard: [
          { required: idCardRequired, message: '2026年9月9日起，成交客户必须填写身份证号', trigger: 'blur' },
          { validator: validateIdCard, trigger: 'blur' }
        ],
        from: [
          { required: true, message: '请选择客户来源', trigger: 'change' }
        ],
        creatorId: [
          { required: true, message: '请选择创建人', trigger: 'change' }
        ],
        creatorDxqId: [],
        customerDxqId: [],
        remark: [
          { type: 'string', max: 500, message: '备注信息不能超过500个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getAccountInfo()
    this.getEmployeeList()
    this.getDxqAccountList()
  },
  methods: {
    // 获取当前登录账号的信息
    getAccountInfo () {
      this.accountInfo.level = window.sessionStorage.getItem('level')
      this.accountInfo.employeeId = window.sessionStorage.getItem('employeeId') || ''
      this.accountInfo.employeeName = window.sessionStorage.getItem('employeeName') || ''
      this.accountInfo.department = window.sessionStorage.getItem('department') || ''
      this.accountInfo.job = window.sessionStorage.getItem('job') || ''
      this.accountInfo.bindDxqId = window.sessionStorage.getItem('bindDxqId') || ''
    },

    // 获取员工列表
    async getEmployeeList () {
      try {
        const { data: res } = await this.$http.get('zhaoshang/customer/employees')
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.employeeList = res.data || []
        // 员工列表加载后，设置默认值
        this.initFormByRole()
      } catch (error) {
        this.$message.error('获取员工列表失败')
      }
    },

    // 获取堆雪球账号列表
    async getDxqAccountList () {
      try {
        const { data: res } = await this.$http.get('zhaoshang/customer/dxq-accounts')
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.dxqAccountList = res.data || []
        // 堆雪球账号列表加载后，设置默认值
        this.initFormByRole()
      } catch (error) {
        this.$message.error('获取堆雪球账号列表失败')
      }
    },

    // 根据角色初始化表单默认值和字段可编辑状态
    initFormByRole () {
      // 如果员工列表或堆雪球账号列表尚未加载完成，则不执行初始化
      if (this.employeeList.length === 0 || this.dxqAccountList.length === 0) {
        return
      }

      const level = parseInt(this.accountInfo.level)
      const job = this.accountInfo.job
      const employeeId = this.accountInfo.employeeId
      const bindDxqId = this.accountInfo.bindDxqId

      // 管理员（level <= 1）：默认为空，可编辑
      if (level <= 1) {
        this.isCreatorEditable = true
        this.isCreatorDxqEditable = true
        // 不设置默认值
        return
      }

      // 主管或总监：默认填充当前用户，可编辑
      if (job === '主管' || job === '总监') {
        this.isCreatorEditable = true
        this.isCreatorDxqEditable = true
        // 设置默认值
        if (employeeId) {
          this.form.creatorId = employeeId
          const creator = this.employeeList.find(item => item._id === employeeId)
          if (creator) {
            this.form.creatorName = creator.name
          }
        }
        if (bindDxqId) {
          this.form.creatorDxqId = bindDxqId
        }
        return
      }

      // 普通员工（job='员工'）：默认填充当前用户，不可编辑
      if (job === '员工') {
        this.isCreatorEditable = false
        this.isCreatorDxqEditable = false
        // 设置默认值
        if (employeeId) {
          this.form.creatorId = employeeId
          const creator = this.employeeList.find(item => item._id === employeeId)
          if (creator) {
            this.form.creatorName = creator.name
          }
        }
        if (bindDxqId) {
          this.form.creatorDxqId = bindDxqId
        }
      }
    },

    // 归属人变化时，更新creatorName并重置归属人微信
    onCreatorChange () {
      // 更新creatorName
      const creator = this.employeeList.find(item => item._id === this.form.creatorId)
      if (creator) {
        this.form.creatorName = creator.name
      }
      // 重置归属人微信
      this.form.creatorDxqId = ''
      this.onCreatorDxqChange()
    },

    // 归属人堆雪球账号变化时，强制清空客户微信选择
    onCreatorDxqChange () {
      this.form.customerDxqId = ''
      this.wechatFriendList = []
    },

    // 搜索微信好友
    async searchWechatFriends (keyword) {
      if (!this.form.creatorDxqId) {
        this.$message.warning('请先选择创建人堆雪球账号')
        return
      }

      this.loadingWechatFriends = true
      try {
        const params = {
          wechatAccountId: this.form.creatorDxqId,
          keyword: keyword
        }
        const { data: res } = await this.$http.get('zhaoshang/customer/wechat-friends', { params })
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.wechatFriendList = res.data || []
      } catch (error) {
        this.$message.error('获取微信好友列表失败')
      } finally {
        this.loadingWechatFriends = false
      }
    },

    // 点击添加按钮
    async okClickHandler () {
      // 防止重复点击：提交中直接拦截
      if (this.submitting) return

      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return false

        // 获取创建人姓名
        const creator = this.employeeList.find(item => item._id === this.form.creatorId)
        if (!creator) {
          this.$message.error('创建人信息错误')
          return false
        }

        const submitData = {
          title: this.form.title,
          name: this.form.name,
          mobile: this.form.mobile,
          idCard: this.form.idCard || '',
          from: this.form.from,
          creatorId: this.form.creatorId,
          creatorName: creator.name,
          creatorDxqId: this.form.creatorDxqId || '',
          customerDxqId: this.form.customerDxqId || '',
          remark: this.form.remark || ''
        }

        console.log(submitData)

        // 进入提交中状态
        this.submitting = true
        try {
          const { data: res } = await this.$http.post('zhaoshang/customer/add', submitData)
          if (res.meta.status !== 200) {
            this.$message.error(res.meta.msg)
            return false
          }
          this.$message.success(res.meta.msg)
          this.goBack()
        } catch (error) {
          this.$message.error('添加客户失败')
        } finally {
          // 无论成功失败，释放提交状态
          this.submitting = false
        }
      })
    },

    // 返回
    goBack () {
      this.$router.push('/zhaoshang/customer')
    }
  }
}
</script>

<style lang="less" scoped>

</style>
